import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
});

let clerkSession = null;

export const setClerkSession = (session) => {
  clerkSession = session;
};

// Keep backward compat
export const setClerkTokenGetter = (getter) => {};

axiosInstance.interceptors.request.use(
  async (requestConfig) => {
    if (clerkSession) {
      try {
        const token = await clerkSession.getToken();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('[axios] Failed to get token:', err);
      }
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// For fetch-based requests (e.g. SSE streams) that can't go through axios.
export const getAuthHeader = async () => {
  if (clerkSession) {
    try {
      const token = await clerkSession.getToken();
      if (token) return { Authorization: `Bearer ${token}` };
    } catch { /* ignore - dev-auth needs no header */ }
  }
  return {};
};

export default axiosInstance;
